import type { ReactNode } from 'react'
import { View } from 'react-native'
import { cn } from '~/lib/utils'

export function FrontPageSectionFrame({
  children,
  className,
  innerClassName,
  variant = 'transparent',
}: {
  children: ReactNode
  className?: string
  innerClassName?: string
  variant?: 'transparent' | 'dark' | 'light'
}) {
  return (
    <View
      className={cn(
        'w-full px-6 sm:px-10',
        variant === 'dark' && 'bg-primary',
        variant === 'light' && 'bg-background',
        className
      )}>
      <View className={cn('mx-auto w-full max-w-5xl', innerClassName)}>{children}</View>
    </View>
  )
}
